import layout from '@/layout/portal'

import Main from '@/pages/report/MainCustom'
import Alarm from '@/pages/report/Alarm'
import Temperature from '@/pages/report/Temperature'
import Humidity from '@/pages/report/Humidity'
import UPS from '@/pages/report/UPS'
import AverageBySubdeviceName from '@/pages/report/AverageBySubdeviceName'

const data = [
  {
    path: '/report',
    name: 'report',
    components: {
      content: Main,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Custom Report' },
        { title: 'List', active: true }
      ],
      title: 'Custom Report List',
      module: 'Custom Report',
      showLink: false
    }
  },
  {
    path: '/report/alarm',
    name: 'Report Alarm',
    components: {
      content: Alarm,
      layout: layout
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/temperature',
    name: 'Report Temperature',
    components: {
      content: Temperature,
      layout: layout
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/humidity',
    name: 'Report Humidity',
    components: {
      content: Humidity,
      layout: layout
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/ups',
    name: 'Report UPS',
    components: {
      content: UPS,
      layout: layout
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/average-by-subdevice-name',
    name: 'report average by subdevice name',
    components: {
      content: AverageBySubdeviceName,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Report Average By Subdevice Name' },
        { title: 'List', active: true }
      ],
      title: 'Report List',
      module: 'Custom Report',
      showLink: false
      // requiresAuth: true,
    }
  }
]
export default data
